// Bilingual dictionary (ES / EN)
export const translations = {
  es: {
    nav: {
      services: "Servicios",
      destinations: "Destinos",
      packages: "Paquetes",
      pricing: "Tarifas",
      book: "Reservar",
      contact: "Contacto",
    },
    hero: {
      overline: "Cancún · Riviera Maya",
      title: "Tu traslado privado al paraíso de Xcaret",
      subtitle:
        "Transportación premium desde el aeropuerto de Cancún a los hoteles y parques Xcaret. Choferes bilingües, unidades nuevas y servicio puntual 24/7.",
      cta: "Reservar mi traslado",
      ctaSecondary: "Ver tarifas",
      stat1: "Servicio",
      stat1v: "24/7",
      stat2: "Clientes felices",
      stat2v: "5,000+",
      stat3: "Bilingüe",
      stat3v: "ES · EN",
    },
    services: {
      overline: "Lo que hacemos",
      title: "Servicios de transportación",
      subtitle: "Cubrimos cada momento de tu viaje, desde que aterrizas hasta tu regreso.",
      items: [
        {
          title: "Aeropuerto → Hotel",
          desc: "Recepción personalizada (meet & greet) en el aeropuerto de Cancún y traslado directo a tu hotel Xcaret.",
        },
        {
          title: "Traslados a Parques",
          desc: "Llega cómodo a Xcaret, Xel-Há, Xplor, Xoximilco y más. Ida y vuelta con horarios flexibles.",
        },
        {
          title: "Tours Riviera Maya & Tulum",
          desc: "Excursiones privadas a Tulum, cenotes y los rincones más bellos de la Riviera Maya.",
        },
      ],
    },
    destinations: {
      overline: "Destinos",
      title: "Te llevamos a donde quieras",
      subtitle: "Hoteles y parques del complejo Xcaret y la Riviera Maya.",
    },
    pricing: {
      overline: "Tarifas",
      title: "Precios de referencia",
      subtitle: "Tarifas por servicio privado (precios de ejemplo en USD). Confirmamos el precio final al reservar.",
      colRoute: "Ruta",
      colVehicle: "Vehículo",
      colPrice: "Desde",
      note: "* Precios por viaje, no por persona. Sujetos a disponibilidad y temporada.",
      cta: "Cotizar mi ruta",
    },
    reservation: {
      overline: "Reserva en línea",
      title: "Solicita tu traslado",
      subtitle: "Completa el formulario y te confirmamos por WhatsApp en minutos.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono / WhatsApp",
      service: "Tipo de servicio",
      vehicle: "Vehículo",
      tripType: "Tipo de viaje",
      oneWay: "Solo ida",
      roundTrip: "Ida y vuelta",
      origin: "Origen",
      destination: "Destino",
      date: "Fecha",
      returnDate: "Fecha de regreso",
      time: "Hora",
      passengers: "Pasajeros",
      adults: "Adultos",
      children: "Menores",
      flight: "Número de vuelo (opcional)",
      notes: "Notas adicionales",
      submit: "Enviar y abrir WhatsApp",
      submitting: "Enviando...",
      success: "¡Reserva enviada! Abriendo WhatsApp...",
      error: "Ocurrió un error. Inténtalo de nuevo.",
      required: "Por favor completa los campos obligatorios.",
      serviceOptions: [
        "Aeropuerto → Hotel",
        "Hotel → Aeropuerto",
        "Traslado a Parques",
        "Tour Riviera Maya / Tulum",
      ],
      placeholderOrigin: "Ej. Aeropuerto Cancún (CUN)",
      placeholderDest: "Ej. Hotel Xcaret México",
    },
    why: {
      overline: "Por qué elegirnos",
      title: "Viaja con tranquilidad",
      items: [
        { title: "Choferes bilingües", desc: "Personal profesional que habla español e inglés." },
        { title: "Unidades nuevas", desc: "Vans y SUVs con aire acondicionado, cómodas y seguras." },
        { title: "Monitoreo de vuelos", desc: "Seguimos tu vuelo: si hay retraso, te esperamos." },
        { title: "Servicio 24/7", desc: "Atención y traslados a cualquier hora del día." },
      ],
    },
    testimonials: {
      overline: "Testimonios",
      title: "Lo que dicen nuestros clientes",
      items: [
        { name: "María G.", text: "Servicio impecable. El chofer nos esperaba con un letrero y la van estaba impecable. ¡100% recomendado!" },
        { name: "John D.", text: "Punctual and very professional. Smooth ride from Cancun airport to Hotel Xcaret. Will book again!" },
        { name: "Laura P.", text: "Reservé por WhatsApp en minutos. Excelente trato y precio justo. Volveré a usarlos." },
      ],
    },
    contact: {
      overline: "Contacto",
      title: "¿Listo para reservar?",
      subtitle: "Escríbenos por WhatsApp o llena el formulario. Te respondemos al instante.",
      whatsapp: "Escribir por WhatsApp",
      call: "Llamar ahora",
    },
    footer: {
      tagline: "Transportación privada premium en Cancún y Riviera Maya.",
      quickLinks: "Enlaces",
      contact: "Contacto",
      rights: "Todos los derechos reservados.",
    },
    fleet: {
      overline: "Nuestra flota",
      title: "Elige tu tipo de vehículo",
      subtitle: "Selecciona la unidad ideal para tu grupo. Todas con aire acondicionado y chofer profesional.",
      seats: "pasajeros",
      selected: "Seleccionado",
      choose: "Seleccionar",
    },
    search: {
      title: "El mejor transporte de Cancún a la Riviera Maya",
      subtitle: "Traslados a los mejores destinos. Más de 10 años brindando la mejor transportación en toda la Riviera Maya.",
      oneWay: "Ida",
      roundTrip: "Ida y Vuelta",
      from: "Saliendo de",
      to: "Ir a",
      fromPlaceholder: "Ingresa el lugar de recogida",
      toPlaceholder: "Indica el destino",
      pickupDate: "Fecha de recogida",
      returnDate: "Fecha de regreso",
      passengers: "Pasajeros",
      adults: "Adultos",
      children: "Menores",
      search: "BUSCAR",
      trust: "Servicio de primera, comodidad y confianza en cada viaje.",
    },
    whatsappMsg: "Hola XCARET MEXICO, quiero información sobre un traslado.",
    packages: {
      overline: "Paquetes todo incluido",
      title: "Transporte + tour en un solo paquete",
      subtitle: "Experiencias completas armadas para ti, combinando traslados, hoteles y parques. Reserva y paga en línea de forma segura.",
      includes: "Incluye",
      buy: "Comprar ahora",
      featured: "Más vendido",
      dialogTitle: "Completa tu compra",
      dialogSub: "Serás redirigido a Whop para completar el pago seguro.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono / WhatsApp",
      date: "Fecha del servicio",
      pay: "Continuar al pago",
      paying: "Procesando...",
      secure: "Pago seguro procesado por Whop",
      required: "Completa nombre, correo y teléfono.",
      error: "No se pudo iniciar el pago. Intenta de nuevo.",
      summary: "Resumen de tu compra",
      checkoutTitle: "Finaliza tu compra",
      continue: "Continuar al pago seguro",
      loadingPay: "Cargando pago seguro...",
      back: "Volver a paquetes",
      yourData: "Tus datos",
    },
  },

  en: {
    nav: {
      services: "Services",
      destinations: "Destinations",
      packages: "Packages",
      pricing: "Rates",
      book: "Book",
      contact: "Contact",
    },
    hero: {
      overline: "Cancún · Riviera Maya",
      title: "Your private transfer to the Xcaret paradise",
      subtitle:
        "Premium transportation from Cancún airport to the Xcaret hotels and parks. Bilingual drivers, new vehicles and punctual 24/7 service.",
      cta: "Book my transfer",
      ctaSecondary: "View rates",
      stat1: "Service",
      stat1v: "24/7",
      stat2: "Happy guests",
      stat2v: "5,000+",
      stat3: "Bilingual",
      stat3v: "ES · EN",
    },
    services: {
      overline: "What we do",
      title: "Transportation services",
      subtitle: "We cover every moment of your trip, from landing to your return.",
      items: [
        {
          title: "Airport → Hotel",
          desc: "Personalized meet & greet at Cancún airport and direct transfer to your Xcaret hotel.",
        },
        {
          title: "Park Transfers",
          desc: "Arrive comfortably at Xcaret, Xel-Há, Xplor, Xoximilco and more. Round trips with flexible times.",
        },
        {
          title: "Riviera Maya & Tulum Tours",
          desc: "Private excursions to Tulum, cenotes and the most beautiful spots of the Riviera Maya.",
        },
      ],
    },
    destinations: {
      overline: "Destinations",
      title: "We take you wherever you want",
      subtitle: "Hotels and parks of the Xcaret complex and the Riviera Maya.",
    },
    pricing: {
      overline: "Rates",
      title: "Reference pricing",
      subtitle: "Private service rates (sample prices in USD). We confirm the final price when you book.",
      colRoute: "Route",
      colVehicle: "Vehicle",
      colPrice: "From",
      note: "* Prices per trip, not per person. Subject to availability and season.",
      cta: "Quote my route",
    },
    reservation: {
      overline: "Book online",
      title: "Request your transfer",
      subtitle: "Fill out the form and we'll confirm via WhatsApp within minutes.",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      service: "Service type",
      vehicle: "Vehicle",
      tripType: "Trip type",
      oneWay: "One way",
      roundTrip: "Round trip",
      origin: "Origin",
      destination: "Destination",
      date: "Date",
      returnDate: "Return date",
      time: "Time",
      passengers: "Passengers",
      adults: "Adults",
      children: "Minors",
      flight: "Flight number (optional)",
      notes: "Additional notes",
      submit: "Send & open WhatsApp",
      submitting: "Sending...",
      success: "Reservation sent! Opening WhatsApp...",
      error: "Something went wrong. Please try again.",
      required: "Please fill in the required fields.",
      serviceOptions: [
        "Airport → Hotel",
        "Hotel → Airport",
        "Park Transfer",
        "Riviera Maya / Tulum Tour",
      ],
      placeholderOrigin: "e.g. Cancún Airport (CUN)",
      placeholderDest: "e.g. Hotel Xcaret México",
    },
    why: {
      overline: "Why choose us",
      title: "Travel with peace of mind",
      items: [
        { title: "Bilingual drivers", desc: "Professional staff who speak Spanish and English." },
        { title: "New vehicles", desc: "Air-conditioned vans and SUVs, comfortable and safe." },
        { title: "Flight monitoring", desc: "We track your flight: if it's delayed, we wait for you." },
        { title: "24/7 service", desc: "Support and transfers any time of the day." },
      ],
    },
    testimonials: {
      overline: "Testimonials",
      title: "What our guests say",
      items: [
        { name: "María G.", text: "Impeccable service. The driver waited for us with a sign and the van was spotless. 100% recommended!" },
        { name: "John D.", text: "Punctual and very professional. Smooth ride from Cancun airport to Hotel Xcaret. Will book again!" },
        { name: "Laura P.", text: "Booked via WhatsApp in minutes. Great service and fair price. Will use them again." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Ready to book?",
      subtitle: "Message us on WhatsApp or fill out the form. We reply instantly.",
      whatsapp: "Message on WhatsApp",
      call: "Call now",
    },
    footer: {
      tagline: "Premium private transportation in Cancún and Riviera Maya.",
      quickLinks: "Links",
      contact: "Contact",
      rights: "All rights reserved.",
    },
    fleet: {
      overline: "Our fleet",
      title: "Choose your vehicle type",
      subtitle: "Select the ideal unit for your group. All with air conditioning and a professional driver.",
      seats: "passengers",
      selected: "Selected",
      choose: "Select",
    },
    search: {
      title: "The best transport from Cancún to the Riviera Maya",
      subtitle: "Transfers to the best destinations. Over 10 years providing the best transportation across the Riviera Maya.",
      oneWay: "One way",
      roundTrip: "Round trip",
      from: "Departing from",
      to: "Going to",
      fromPlaceholder: "Enter pickup location",
      toPlaceholder: "Enter destination",
      pickupDate: "Pickup date",
      returnDate: "Return date",
      passengers: "Passengers",
      adults: "Adults",
      children: "Minors",
      search: "SEARCH",
      trust: "First-class service, comfort and trust on every trip.",
    },
    whatsappMsg: "Hi XCARET MEXICO, I'd like information about a transfer.",
    packages: {
      overline: "All-inclusive packages",
      title: "Transport + tour in a single package",
      subtitle: "Complete experiences built for you, combining transfers, hotels and parks. Book and pay online securely.",
      includes: "Includes",
      buy: "Buy now",
      featured: "Best seller",
      dialogTitle: "Complete your purchase",
      dialogSub: "You'll be redirected to Whop to complete the secure payment.",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      date: "Service date",
      pay: "Continue to payment",
      paying: "Processing...",
      secure: "Secure payment processed by Whop",
      required: "Please fill in name, email and phone.",
      error: "Could not start payment. Please try again.",
      summary: "Order summary",
      checkoutTitle: "Complete your purchase",
      continue: "Continue to secure payment",
      loadingPay: "Loading secure payment...",
      back: "Back to packages",
      yourData: "Your details",
    },
  },
};
